/**
* アコーディオンのコンストラクタ
* @constructor
*/
module.exports = Accordion = function(){};

/**
* initialize
* @param {selector} el - jquery セレクタ
* @param {selector} parent - jquery セレクタ
*/
Accordion.prototype.init = function(el, parent){
  this.element = $(el);
  this.parent = $(parent);
  this.event();
}

/**
* event
*/
Accordion.prototype.event = function(){
  var self = this;

  var active = 'is-active';

  this.element.prop('checked', false).removeClass(active);

  this.element.on('change', function(){
    var isChecked = self.element.prop('checked');
    if(isChecked){
      self.parent.addClass(active);
    }else{
      self.parent.removeClass(active);
    }
  });
}





//////////////////
// WEBPACK FOOTER
// ./js/_modules/accordion.js
// module id = 3
// module chunks = 0